import React from "react";
import MaskImage from "../../assets/Mask group.png";
import { ArrowRight2 } from "iconsax-reactjs";
import { motion } from "framer-motion";

function Landing() {
  return (
    <motion.div
      id="Home"
      className="pt-48 sm:pt-32 px-10 sm:px-24 xl:px-48 flex flex-col lg:flex-row justify-center lg:justify-between items-center w-full"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <div>
        <motion.h1
          className="text-[#1F1F1E] text-4xl sm:text-6xl md:text-7xl xl:text-8xl leading-[90%] changa-one-regular"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          viewport={{ once: true }}
        >
          WE BUILD <br /> STRONGER <br /> FUTURE
        </motion.h1>
        <motion.p
          className="text-[#1F1F1E] actor-regular text-xl mt-6 mb-14"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          Building stronger future, <br /> one steel beam at a time
        </motion.p>
        <motion.button
          className="bg-[#EEB762] px-5 lg:px-7 py-3 lg:py-4 flex items-center gap-1 lg:gap-2 rounded-[8px]"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <span className="flex flex-col inter-medium text-white text-sm lg:text-base leading-tight text-left mr-8 lg:mr-12">
            START
            <span className="mt-1">COLLABORATING</span>
          </span>
          <ArrowRight2 size="13" color="#fff" />
        </motion.button>
      </div>
      <motion.img
        src={MaskImage}
        alt=""
        className="hidden sm:block w-[250px] h-[500px] lg:w-[300px] lg:h-[650px] object-contain"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        viewport={{ once: true }}
      />
    </motion.div>
  );
}

export default Landing;
